/**
 * F-0743 §4 (VSB-35): the phone's search bar rests tucked under the top row (S-5) and comes down on
 * a pull. What the bar listens for to come down without one: ⌘K on a hardware keyboard.
 */
export const REVEAL_PHONE_BAR_EVENT = 'featit:reveal-phone-bar';

/**
 * VSB-35c: whether a search is set, so the bar stays shown and the reader sees the list is
 * narrowed — the address's `?q=` (a view's search, Items'), or text in the bar itself.
 */
export function phoneBarHeld(search: string, typed: string): boolean {
  return (new URLSearchParams(search).get('q') ?? '').trim() !== '' || typed.trim() !== '';
}
